export const APPLE_SIGN_IN_SCRIPT =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
export const APPLE_SIGN_IN_SCOPE = "email name";
